import {isString} from "./utils"

export default class DOMUtils {

    static insertAtTheEnd($parent, $element) {
        if (isString($element)) {
            $element = DOMUtils.createElementFromString($element)
        }
        if ($element) {
            if (!$parent.lastElementChild) {
                $parent.innerHTML = DOMUtils.getHTML($element)
            } else {
                $parent.lastElementChild.parentNode.insertBefore($element, $parent.lastElementChild.nextSibling)
            }
        } else {
            console.error("insertAtTheEnd", $element)
        }
    }

    static insertAtEndOfBody($element) {
        DOMUtils.insertAtTheEnd(document.querySelector("body"), $element)
    }

    static getElementFromTemplate(template) {
        return template && template.content && template.content.children && template.content.children.length ? template.content.children[0] : false
    }

    static createTemplate(HTML) {
        let template = document.createElement("template")
        template.innerHTML = HTML
        return template
    }

    static createElementFromString(string) {
        const div = document.createElement('div')
        div.innerHTML = string.trim()
        return div.firstChild
    }

    static cloneElement($target){
        const wrap = document.createElement('div')
        wrap.appendChild($target.cloneNode(true))
        return wrap.firstChild
    }

    static getHTML($target) {
        if ($target.outerHTML) {
            return $target.outerHTML
        } else {
            const wrap = document.createElement('div')
            wrap.appendChild($target.cloneNode(true))
            return wrap.innerHTML
        }
    }

    static getListHTML($list){
        let html = ""
        $list.forEach($item => html += DOMUtils.getHTML($item))
        return html
    }

}